import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { LoginPageComponent } from './login-page.component';
import { LoginService } from './login.service';
import { FormsModule } from '@angular/forms';

const states: Ng2StateDeclaration[] = [
  {
    name: 'login',
    url: '/login',
    component: LoginPageComponent
  }
];

@NgModule({
  declarations: [LoginPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [LoginPageComponent],
  providers: [LoginService]
})
export class LoginPageModule { }
